import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type UploadToSharepointVariables = {
  fileId: number;
  uploadUrl: string;
} & ({ clientId: string; familyId?: never } | { familyId: string; clientId?: never });

type UploadedSharepointItem = {
  id: string;
  name: string;
  webUrl: string;
  size: number | null;
};

export function useUploadToSharepointMutation() {
  return useMutation<{ data: UploadedSharepointItem }, Error, UploadToSharepointVariables>({
    mutationFn: variables => {
      const { fileId, uploadUrl } = variables;
      const [url, body] =
        'familyId' in variables && variables.familyId
          ? ([
              `families/${variables.familyId}/sharepoint-docs/upload`,
              { fileId, uploadUrl },
            ] as const)
          : ([
              'sharepoint-docs/upload',
              { fileId, clientId: variables.clientId, uploadUrl },
            ] as const);
      return api.post<UploadedSharepointItem>(
        url,
        body,
        // The backend reads the full file from S3 and streams it to Graph synchronously,
        // so large files can take several minutes. 5 minutes avoids a premature abort.
        { timeoutMs: 300_000 },
      );
    },
  });
}
